module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_mobirix.dcb05f0426e5b81be58fd26e4763ac51.png";